import styled from 'styled-components';

const Price = styled.span`
  color: ${({ theme }) => theme.colors.night_blue_1};
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumBold};
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export default Price;
